var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transport"},[_c('h4',[_c('font',{attrs:{"face":"verdana, arial, helvetica","size":"2"}},[_vm._v("Please wait while we process your login... This should take 1 second.")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }